module.exports = __webpack_public_path__ + "static/media/logo_transaprente.f4a3d386.png";